export default "__VITE_ASSET__DB8D5lzd__"